module.exports = __webpack_public_path__ + "static/media/JC.1595a3ea.png";